/**
 * Criteo Functions
 *
 * @see https://help.criteo.com/kb/guide/en/introduction-to-the-criteo-onetag-8fjCDwCENw
 */

(function (pmw, undefined) {

	/**
	 * Get the Criteo site type
	 *
	 * Criteo distinguishes tablet ("t"), mobile ("m") and desktop ("d")
	 * traffic. The detection mirrors the snippet from the Criteo OneTag
	 * documentation.
	 */
	const getCriteoSiteType = () => {
		if (/iPad/.test(navigator.userAgent)) return "t";
		if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)) return "m";
		return "d";
	};

	/**
	 * Load the Criteo OneTag
	 *
	 * Injects the OneTag loader script and initializes the criteo_q event
	 * queue with the account ID and site type. The queue works before the
	 * loader script has finished loading, so events pushed right after this
	 * are processed as soon as the OneTag is ready.
	 */
	pmw.loadCriteoPixel = () => {
		try {
			window.criteo_q = window.criteo_q || [];

			const script = document.createElement("script");
			script.async = true;
			script.src   = "https://dynamic.criteo.com/js/ld/ld.js?a=" + pmwDataLayer.pixels.criteo.account_id;
			document.getElementsByTagName("head")[0].appendChild(script);

			const initEvents = [
				{event: "setAccount", account: pmwDataLayer.pixels.criteo.account_id},
				{event: "setSiteType", type: getCriteoSiteType()},
			];

			// With advanced matching enabled, send the SHA-256 hashed email of
			// logged-in customers and purchasers to improve match rates.
			if (
				pmwDataLayer?.pixels?.criteo?.advanced_matching &&
				pmwDataLayer?.user?.email?.sha256
			) {
				initEvents.push({
					event      : "setEmail",
					email      : pmwDataLayer.user.email.sha256,
					hash_method: "sha256",
				});
			}

			window.criteo_q.push(...initEvents);

			pmwDataLayer.pixels.criteo.loaded = true;

			pmw.console.log("Criteo: pixel loaded");

			// The homepage view is a dedicated Criteo event and has no
			// standardized Pixel Manager event, so it is sent right after load.
			if ("front_page" === pmwDataLayer?.shop?.page_type) {
				pmw.criteoTrackEvent({event: "viewHome"});
			}

		} catch (e) {
			console.error(e);
		}
	};

	/**
	 * Push an event to the Criteo OneTag queue
	 *
	 * @param {Object} criteoData - Adapted Criteo event from the event payload
	 */
	pmw.criteoTrackEvent = (criteoData) => {
		try {
			if (!criteoData?.event) return;

			window.criteo_q = window.criteo_q || [];
			window.criteo_q.push(criteoData);

			pmw.console.log("Criteo: " + criteoData.event + " event sent", criteoData);

		} catch (e) {
			console.error(e);
		}
	};

}(window.pmw = window.pmw || {}));
